import { render } from "./PledgeSubmittedVideo.vue?vue&type=template&id=0ca4691a"
import script from "./PledgeSubmittedVideo.vue?vue&type=script&lang=js"
export * from "./PledgeSubmittedVideo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__